import { Routes } from '@angular/router';
import { routes as pagesRoutes } from './views/pages/pages.routing';

export const routes: Routes = [{ path: '', redirectTo: 'app', pathMatch: 'full' }, ...pagesRoutes, { path: '**', redirectTo: 'app/me' }];
